import { useState } from 'react';
import { useReduxState } from 'hooks';
import { Button } from 'components/common';
import { ReviewForm } from '.';

interface Props {
  answerId: number;
  answerUserEmail?: string;
  courseId: number;
  gradingType: 'text' | 'text-and-stars' | 'text-and-points';
  isTaskEditable?: boolean;
  maxPoints: number;
  onDataChange: () => Promise<void>;
  onlyComments: boolean;
  keepOpen: boolean;
}

const ReviewEditable = ({
  answerId,
  answerUserEmail,
  courseId,
  gradingType,
  isTaskEditable,
  maxPoints,
  onDataChange,
  onlyComments,
  keepOpen
}: Props) => {
  const { messages } = useReduxState();

  const [editing, setEditing] = useState<boolean>(keepOpen);

  const handleClose = () => {
    setEditing(false);
  };

  const handleEdit = () => {
    setEditing(true);
  };

  return (
    <div className="review-add">
      {editing ? (
        <ReviewForm
          answerId={answerId}
          answerUserEmail={answerUserEmail}
          courseId={courseId}
          gradingType={gradingType}
          isTaskEditable={isTaskEditable}
          maxPoints={maxPoints}
          onClose={handleClose}
          onlyComments={onlyComments}
          onSuccess={onDataChange}
          keepOpen={keepOpen}
        />
      ) : (
        <Button
          category="light"
          onClick={handleEdit}
          text={
            onlyComments ? messages.commonAddComment : messages.tasksAddReview
          }
        />
      )}
    </div>
  );
};

export default ReviewEditable;
